import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { currencyString } from "@qgiv/core-js";
import { getFormattedPrice } from "@qgiv/core-donor";
import { selectReceipt } from "../../../redux/slices/receiptSlice";
import { selectSpecificFormSetting } from "../../../redux/slices/formSettingsSlice";
import { selectAllP2pSettings } from "../../../redux/slices/p2pSettingsSlice";
import ReceiptStoreItem from "./ReceiptStoreItem";

const ConnectedReceiptStoreItem = ({ id /* references store item id */ }) => {
    const receipt = useSelector(selectReceipt);
    const currency = useSelector((state) =>
        selectSpecificFormSetting(state, "currency"),
    );
    const p2pSettings = useSelector(selectAllP2pSettings);
    const { registrationFeeDisplay, registrationFeeDisplayText } = p2pSettings;
    const {
        transaction: {
            store: { cart = [] },
        },
    } = receipt;

    const storeItem = cart[id];
    const {
        attributes = [],
        itemTotalCost = 0.0,
        unitCost = 0.0,
        qtySold = 0,
        title = "",
    } = storeItem;

    const formattedTotalItemAmount = getFormattedPrice(
        itemTotalCost,
        currency,
        registrationFeeDisplay,
        registrationFeeDisplayText,
    );

    let formattedUnitCost = "";
    if (qtySold > 1 && itemTotalCost > 0) {
        formattedUnitCost = currencyString(unitCost, currency);
    } else if (qtySold > 1 && itemTotalCost === 0) {
        formattedUnitCost = formattedTotalItemAmount;
    }

    const receiptStoreItemProps = {
        attributes,
        formattedTotalItemAmount,
        formattedUnitCost,
        qtySold,
        title,
    };

    return <ReceiptStoreItem {...receiptStoreItemProps} />;
};

ConnectedReceiptStoreItem.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default ConnectedReceiptStoreItem;
